import {Button, DialogActions, Grid, IconButton, InputAdornment, Stack, TextField} from "@mui/material";
import { Checkbox } from "../../../../utils/form";
import _ from "lodash";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import CustomDialog from "../../../../utils/CustomDialog";
import ClearIcon from '@mui/icons-material/Clear'; // Importa el ícono para la "X"

const SetContentPicker = ({
  selectedTemplate,
  form,
  name,
  defaultContent = "",
  setSelectedTemplate,
  index,
  remove,
}) => {
  const [open, setOpen] = useState(true);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [search, setSearch] = useState("");
  const toggleOpen = () => setOpen((open) => !open);
  const medicines = form.getValues(`medicines`);
  const template = form.getValues(`medicines[${index}].template`)?.name;
  const options = _.split(selectedTemplate.content, ",").map((option, idx) => ({
    id: idx,
    label: option,
  }));
  const optionsForm = useForm({
    defaultValues: {
      options: _.reduce(
          options,
          (result, option) => {
            result[option.id] = false;
            return result;
          },
          {}
      ),
    },
  });

  useEffect(() => {
    if (_.size(options) > 100 && _.size(search) < 3) return;
    const filtered = options.filter((option) => {
      return option.label.toLowerCase().includes(search.toLowerCase());
    });
    setFilteredOptions(filtered);
  }, [search, selectedTemplate]);

  useEffect(() => {
    if (
      options.length > 0 &&
      !open &&
      medicines.length > 1 &&
      (template !== "Nueva solicitud" || template !== "Nuevo medicamento")
    ) {
      remove(index);
      setSelectedTemplate(null);
    } else if (!open) {
      setSelectedTemplate(null);
    }
  }, [options, open]);

  const onAccept = () => {
    const selectedIds = _.filter(
        options,
        (option) => optionsForm.getValues(`options`)[option.id]
    ).map((option) => option.label);

    const fieldOptions = _(selectedIds)
        .map((option) => `- ${option}`)
        .join("\n");

    const fieldValue = `${defaultContent}${fieldOptions}`;

    const emptyTextIndex = medicines.findIndex(
      (medicine) => medicine.text === "" || medicine.text === "\n"
    );

    if (emptyTextIndex !== -1) {
      form.setValue(`medicines[${emptyTextIndex}].text`, fieldValue);
      form.setValue(
        `medicines[${emptyTextIndex}].template`,
        selectedTemplate
      );
    }
    toggleOpen();
    setSelectedTemplate(null);
  };

  const handleClearSearch = () => setSearch("");

  const handleCheckboxChange = (optionId, isChecked) => {
    setSelectedOptions((prevSelectedOptions) => {
      if (isChecked) {
        return [...prevSelectedOptions, optionId];
      } else {
        return prevSelectedOptions.filter((id) => id !== optionId);
      }
    });
  };

    return (
    <CustomDialog
      onClose={toggleOpen}
      open={open}
      title={"Seleccione las opciones a utilizar"}
      heigth={600}
      isBottom={true}
      Actions={(
        <DialogActions
          sx={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
            p: 1,
          }}
        >
          <Button variant="contained" onClick={onAccept}>
            Aceptar
          </Button>
        </DialogActions>
      )}
    >
      <Stack p="1rem" spacing="1rem">
        <TextField
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="form-control mt-3"
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton onClick={handleClearSearch} edge="end">
                            <ClearIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
        <form>
          <Grid container>
            {_.map(filteredOptions, (option) => (
                <Grid
                    item
                    xs={12}
                    sm={6}
                    key={option.id}
                    style={{ wordBreak: "break-word" }}
                >
                  <Checkbox
                      form={optionsForm}
                      name={`options[${option.id}]`}
                      label={option.label}
                      onChange={(e) =>
                          handleCheckboxChange(option.id, e.target.checked)
                      }
                      checked={selectedOptions.includes(option.id)}
                  />
                </Grid>
            ))}
          </Grid>
        </form>
      </Stack>
    </CustomDialog>
  );
};

const TextContentPicker = ({ selectedTemplate, form, setSelectedTemplate }) => {
  useEffect(() => {
    const medicines = form.getValues("medicines");

    const emptyTextIndex = medicines.findIndex(
      (medicine) => medicine.text === "" || medicine.text === "\n"
    );

    if (emptyTextIndex !== -1) {
      form.setValue(
        `medicines[${emptyTextIndex}].text`,
        selectedTemplate.content
      );
      form.setValue(
        `medicines[${emptyTextIndex}].template`,
        selectedTemplate
      );

      setSelectedTemplate(null);
    }
  }, [selectedTemplate]);
};

const TemplateContentPicker = (props) => {
  const { selectedTemplate } = props;

  if (_.isEmpty(selectedTemplate)) return null;
  const { inputMethod } = selectedTemplate;

  if (inputMethod === "text") return <TextContentPicker {...props} />;

  return <SetContentPicker {...props} />;
};

export default TemplateContentPicker;
